/*
 * @Author: your name
 * @Date: 2022-03-27 17:09:57
 * @LastEditTime: 2022-03-27 23:41:17
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\utils\app-service.js
 */

/**
 * 是否在微信中打开应用
 */
const openInWeChat = function () {
    if(window.navigator.userAgent.indexOf("MicroMessenger") != -1)
        return true
    return false
}

/**
 * 修改当前应用的标题
 */
const updateAppTitle = function(title) {
    console.log(title)
    if(openInIOS()) {
        window.setDocumentTitle = function () {
            var i = document.createElement('iframe');
            i.src = '../favicon.ico';
            i.style.display = 'none';
            i.onload = function () {
                setTimeout(function () {
                    i.remove();
                }, 9)
            }
            document.body.appendChild(i);
        }

    }
    else{
        document.getElementsByTagName('title')[0].innerHTML = title;
    }
}

/**
 * 是否ios系统打卡当前应用 
 * @returns 
 */
const openInIOS = function() {
    var agent = window.navigator.userAgent

    // 是否安卓系统
    // var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    
    var isIOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    return isIOS
}

export default {
    openInWeChat,
    updateAppTitle,
    openInIOS,
}